import { Card } from '@/components/reports/card';

import RewardCompletions from "../../rewards/components/RewardCompletions";

import { CardTitle } from './utils';

export default function RewardResults({ data }) {
  return <Card title={<CardTitle title="Reward Results" subtitle={`total: ${data?.length}`} />}>
    <RewardCompletions data={data} className='mt-0!' />
  </Card>
}
